import { render, staticRenderFns } from "./AvailableVariants.vue?vue&type=template&id=581f363d&scoped=true"
import script from "./AvailableVariants.vue?vue&type=script&lang=js"
export * from "./AvailableVariants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581f363d",
  null
  
)

export default component.exports